<template>
    <div class="d-flex align-center" style="gap: 10px">
        <v-text-field :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)"
            :label="label" :placeholder="placeholder" style="flex: 1 1 auto" />

        <v-menu :close-on-content-click="false" location="bottom end">
            <template #activator="{ props }">
                <v-btn v-bind="props" variant="outlined" icon size="small" class="colore-swatch-btn"
                    :title="modelValue || 'Nessun colore'">
                    <span class="colore-swatch" :style="{ background: modelValue || '#FFFFFF' }" />
                </v-btn>
            </template>
            <v-card>
                <v-color-picker :model-value="modelValue || '#1976D2'"
                    @update:model-value="$emit('update:modelValue', $event)" mode="hex" />
            </v-card>
        </v-menu>
    </div>
</template>

<script>
// Campo colore riusato ovunque un'entità ha un colore libero associato (tipi
// manutenzione/pagamento/incasso/scadenza mezzo): il campo testo resta per chi
// conosce già il codice hex, il pulsante apre un v-color-picker per la scelta
// visiva. Entrambi scrivono sullo stesso v-model, nessuno stato locale.
export default {
    name: "ColorePickerField",

    props: {
        modelValue: { type: String, default: "" },
        label: { type: String, default: "Colore" },
        placeholder: { type: String, default: "#1976D2" },
    },
    emits: ["update:modelValue"],
};
</script>

<style scoped>
.colore-swatch-btn {
    flex: none;
}

.colore-swatch {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.24);
}
</style>
